import { FormControl, Select } from '@mui/material'
import { Field } from 'formik'

import { Flex } from '@grupoboticario/flora-react'

import FormField from '@/components/FormField/FormField'

const MultiContactTypeInput = ({ isPhone, errors, selectChange }) => (
  <Flex gap="$2">
    <FormField
      invalid={typeof (isPhone ? errors?.phone : errors?.email) === 'string'}
      invalidText={isPhone ? errors?.phone : errors?.email}
      labelText={isPhone ? 'Telefone' : 'Email'}
      name={isPhone ? 'phone' : 'email'}
      required
    />
    <FormControl style={{ width: '100%' }} variant="outlined">
      <Field
        as={Select}
        name="type"
        native
        onChange={selectChange}
        style={{
          boxShadow: 'inset 0 0 0 1px $medium-medium',
          height: '48px'
        }}
      >
        <option value="PERSONAL">Pessoal</option>
        <option value="BUSINESS">Corporativo</option>
      </Field>
    </FormControl>
  </Flex>
)

export default MultiContactTypeInput
